import { useSelector } from "react-redux";
import { Navigate, useParams } from "react-router";
import { ReportType } from "../../../../shared/reporting/api/biClient.types";
import { useEnhancedBiApiClientProvider } from "../../../contexts/ApiClientProviderContext";
import { useClientContext } from "../../../contexts/ClientContext";
import useDefineViewReportData from "../../../hooks/useDefineViewReportData";
import { selectCurrentReport, selectCurrentReportType } from "../../../store/selectors/currentReportSelectors";
import { getApiReportsUrl } from "../common/utilities/editReportUrl";
import { getAdminPortalViewApiReportUrl } from "../getAdminPortalReportUrls";
import RedirectToAdminPortal from "../RedirectToAdminPortal";
import ReportNotFoundOrAccessForbidden from "../ReportNotFoundOrAccessForbidden";

const ViewRoot = () => {
  const { id } = useParams();
  const { clientCode } = useClientContext();
  const report = useSelector(selectCurrentReport);
  const reportType = useSelector(selectCurrentReportType);
  const { getReportsUrl } = useEnhancedBiApiClientProvider();
  const { showReportNotFound } = useDefineViewReportData();

  if (id === undefined) {
    return <Navigate to={getApiReportsUrl(clientCode)} />;
  }

  if (showReportNotFound === true || (report && reportType !== ReportType.Tabular)) {
    return <ReportNotFoundOrAccessForbidden getReportsUrl={getReportsUrl} />;
  }

  return <RedirectToAdminPortal url={getAdminPortalViewApiReportUrl(clientCode, id)} />;
};

export default ViewRoot;
